<!-- MEASUREMENT TYPE - SAFECOR -->

<!-- MEASUREMENT INFORMATION CARD -->
@if (measurement(); as m) {
  <cosmos-measurement-info-card
    [measurement]="m"
    [device]="device()"
    [cardSubtitle]="('measurement.types.CorrosionMeasurement' | translate) + ' - ' + ((m.active ? 'measurement.ongoing' : 'measurement.finished') | translate)"
  >
    <div cardItems class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-database"></i></div>
      <div class="item-text">
        <div class="item-title">{{ 'measurement.corrosion.total_datapoints' | translate }}</div>
        <div class="item-line">
          {{ readingCounts()[1] + readingCounts()[2] }}
          ({{ 'measurement.corrosion.electrodes.electrode1' | translate | lowercase }}: {{ readingCounts()[1] }};
          {{ 'measurement.corrosion.electrodes.electrode2' | translate | lowercase }}: {{ readingCounts()[2] }})
        </div>
      </div>
    </div>

    <ng-container cardFooter>
      <p-confirmdialog />
      <div class="flex flex-wrap gap-2 items-center">
        @if (rbac.canEditProject()) {
          <p-button (click)="editMeasurement()" color="primary"><i class="fa-solid fa-edit"></i> {{ "measurement.edit" | translate }}</p-button>
        }
        @if (m.active && rbac.canEditProject()) {
          <p-button (click)="finishMeasurement($event)" severity="danger"><i class="fa-solid fa-link-slash"></i>{{ "measurement.finish" | translate }}</p-button>
        }
        @if (m.active && rbac.canEditProject()) {
          <p-button (click)="changeDevice(m)" severity="secondary"><i class="fa-solid fa-shuffle"></i>{{ "measurement.change_device" | translate }}</p-button>
        }
        @if (rbac.canEditProject() && tier2Actions().length) {
          <cosmos-measurement-actions-menu [actions]="tier2Actions()" />
        }
      </div>
    </ng-container>
  </cosmos-measurement-info-card>

  <p-divider></p-divider>

  <!-- LAST DATAPOINT (of the selected electrode(s)) -->
  <p-card>
    <ng-template #title>{{ 'measurement.corrosion.insights.last_data_point' | translate }}</ng-template>
    @if (lastReading(); as last) {
      <ng-template #subtitle>{{ last.time | date:'dd/MM/yyyy HH:mm:ss' }}</ng-template>
      <div class="grid gap-4" style="grid-template-columns: repeat(auto-fit, minmax(140px, 1fr))">
        @for (v of readingVariables; track v.key) {
          <div class="flex flex-col gap-0.5">
            <span class="text-sm font-medium text-surface-500 dark:text-surface-400">{{ 'measurement.corrosion.' + v.key | translate }}</span>
            <span class="text-base text-surface-900 dark:text-surface-0">{{ $any(last)[v.key] | number:v.format }} {{ v.unit }}</span>
          </div>
        }
      </div>
    } @else {
      <span class="text-surface-500 dark:text-surface-400">{{ 'measurement.insight.no_data' | translate }}</span>
    }
  </p-card>

  <!-- ELECTRODE SELECTOR -->
  <div class="flex flex-wrap items-center gap-3 my-4">
    <span class="text-base font-semibold text-surface-900 dark:text-surface-0"><i class="fa-solid fa-plug mr-2"></i>{{ 'measurement.corrosion.electrodes.label' | translate }}</span>
    <p-selectbutton
      [options]="electrodeOptions"
      [ngModel]="electrodes()"
      (ngModelChange)="electrodes.set($event)"
      optionValue="value"
      [allowEmpty]="false"
      size="small">
      <ng-template #item let-item>{{ item.labelKey | translate }}</ng-template>
    </p-selectbutton>
    @if (isCropped()) {
      <p-tag severity="info" icon="fa-solid fa-scissors" [value]="'measurement.reschedule.window.chip' | translate" />
    }
  </div>

  <!-- PLOTS: 2 x 2 on desktop -->
  <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
    @for (c of charts; track c.key) {
      <p-card class="min-w-0">
        <ng-template #title>{{ c.titleKey | translate }}</ng-template>
        <ng-template #subtitle>{{ "measurement.chart.subtitle" | translate }}</ng-template>
        <cosmos-dynamic-line-chart
          [dataObject]="plotData()"
          [datasets]="chartSeries()[c.key].datasets"
          [labels]="chartSeries()[c.key].labels"
          [chartId]="'safecor_' + c.key"
          [downloadAllowed]="true"
          [downloadName]="m.name + '-' + c.key"
          (datapointClick)="onDatapointClick($event)">
        </cosmos-dynamic-line-chart>
      </p-card>
    }
  </div>
}
